import CCOM from './CCOM';

class Volume {
    eventVolumeDown = null;

    eventVolumeUp = null;

    constructor() {
        if (CCOM && CCOM.System) {
            this.createEvents();
            this.attachEvent();
        }
    }

    createEvents() {
        this.eventVolumeDown = window.document.createEvent('Event');
        this.eventVolumeDown.initEvent('volumeDown', true, true);
    }

  attachEvent() {
    window.document.addEventListener("volumeDown", function (e) {
      if(CCOM && CCOM.System && CCOM.System.volume &&  CCOM.ConfigManager){
        const volume = CCOM.System.volume - 1;

        if (volume >= 0) {
          CCOM.System.volume = volume;
          CCOM.ConfigManager.setValue("/applications/shared/system.current.volume", volume);
        }
      }
    }, false);

    window.document.addEventListener("volumeUp", function (e) {
      if(CCOM && CCOM.System && CCOM.System.volume &&  CCOM.ConfigManager){
        const volume = CCOM.System.volume + 1;

        if (volume <= 100) {
          CCOM.System.volume = volume;
          CCOM.ConfigManager.setValue("/applications/shared/system.current.volume", volume);
        }
      }
    }, false);
  }

  get() {
    if(CCOM && CCOM.System) {
      return CCOM.System.volume;
    }
    return null;
  }

    get() {
        if (CCOM && CCOM.System) {
            return CCOM.System.volume;
        }
    }

    up() {
        window.document.dispatchEvent(this.eventVolumeUp);
    }

  mute() {
    switch (true) {
        case CCOM && CCOM.System && CCOM.System.volume > 0:
            this.currentVol = CCOM.System.volume;
            CCOM.System.volume = 0;
            CCOM.ConfigManager.setValue("/applications/shared/system.current.volume", 0);
            break;
        case CCOM && CCOM.System && CCOM.System.volume == 0:
            CCOM.System.volume = this.currentVol;
            CCOM.ConfigManager.setValue("/applications/shared/system.current.volume", this.currentVol);
            break;
    }

    return CCOM && CCOM.System && CCOM.System.volume;

        return CCOM.System.volume;
    }
}

export default new Volume();



// WEBPACK FOOTER //
// ./src/devices/nagra/Volume.js